module.exports = __webpack_public_path__ + "img/pic_two.45ac8325.png";